import React from 'react';
import { Field, useFormikContext } from 'formik';
import {
  Checkbox as RebassCheckbox,
  CheckboxProps as RebassCheckboxProps,
  Label,
} from '@rebass/forms';
import { Box } from 'rebass';

type CheckboxProps = Omit<RebassCheckboxProps, 'css'> & {
  label: string;
  name: string;
  value: string;
};

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  name,
  value,
  ...props
}) => {
  let { handleChange, values } = useFormikContext<any>();

  const checkedValuesForFieldName: string[] = values[name];

  const labelVariant = checkedValuesForFieldName.includes(value)
    ? 'checkbox.checkedLabel'
    : 'checkbox.uncheckedLabel';

  return (
    <Box tx="forms" variant="checkbox" {...props}>
      <Label
        tx="forms"
        variant={labelVariant}
        onMouseDown={e => e.preventDefault()}
      >
        <RebassCheckbox
          as={Field}
          name={name}
          data-testid={name}
          value={value}
          onChange={handleChange}
        />
        {label}
      </Label>
    </Box>
  );
};
